import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN = "crk_token";
const PANEL = "crk_panel";

export const tokens = {
  get: () => localStorage.getItem(TOKEN),
  set: (t) => localStorage.setItem(TOKEN, t),
  getPanel: () => localStorage.getItem(PANEL),
  setPanel: (t) => localStorage.setItem(PANEL, t),
  clear: () => {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(PANEL);
  },
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = tokens.get();
  const p = tokens.getPanel();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (p) cfg.headers["X-Panel-Token"] = p;
  return cfg;
});

export function errMsg(e, fallback = "Terjadi kesalahan, coba lagi") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message === "Network Error" ? "Koneksi terputus" : fallback;
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => (x.msg || "").replace(/^Value error, /, "")).join(", ");
  return fallback;
}

export async function downloadCsv(params, filename) {
  const res = await api.get("/export", { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
